<template>
    <views class="verify-result">
        <nav-bar
            :title="moduleTitle"
            @click-left="onClickLeft">
        </nav-bar>
        <views class="result">
            <views v-if="!(isPrize || isTrace) && isSuccess" class="result-info">
                <views class="result-info-title">{{ query.product_name }}</views>
                <views class="result-info-des">
                    <views class="result-info-brand">品牌：{{ query.product_brand }}</views>
                    <views class="result-info-count">已查询 {{ query.count }} 次</views>
                </views>
            </views>
            <views v-if="!(isPrize || isTrace) && isSuccess" class="result-line"></views>
            <views class="result-content">
                <views class="li">
                    <images :src="resultImg"></images>
                </views>
                <views class="li title">{{ resultTitle }}</views>
                <views class="li" v-if="!(isPrize || isTrace) && isSuccess">感谢购买中阿化肥产品</views>
                <views class="li" v-if="!(isPrize || isTrace) && isSuccess">
                    经检验您购买的产品为 <views :class="{'fail': !isSuccess}" class="tag">{{ resultTag }}</views>
                </views>
                <views class="li view-pic" v-if="!(isPrize || isTrace) && isSuccess" @click="handleViewPic">
                    查看产品合格证 <images :src="moreIcon"></images>
                </views>
                <views class="li" v-if="!isSuccess">{{ isPublic ? '明' : '暗' }}码信息不存在</views>
            </views>
            <views class="result-menus">
                <views
                    v-for="item in buttonList"
                    :key="item.text"
                    class="result-menus-list">
                    <button
                        :class="item.type"
                        @click="handleAction(item)">{{ item.text }}</button>
                </views>
            </views>
            <views class="result-wx">
                <images :src="wxCode"></images>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import storage from '@/utils/storage'
export default {
    name: 'Verify',
    mixins: [tools],
    components: {
        NavBar
    },
    data() {
        return {
            data: {},
            verifySuc: require('@/assets/images/verify_suc.png'),
            verifyFail: require('@/assets/images/verify_fail.png'),
            wxCode: require('@/assets/images/wx_code.jpg'),
            moreIcon: require('@/assets/images/awr2.png'),
            defaultButtonList: [
                {
                    type: 'default',
                    text: '再次查伪',
                    action: 'retry'
                },
                {
                    type: 'default',
                    text: '深度防伪',
                    action: 'verifyDark'
                },
                {
                    type: 'primary',
                    text: '马上抽奖',
                    action: 'prize'
                },
                {
                    type: 'default',
                    text: '回到首页',
                    action: 'home'
                },
                {
                    type: 'primary',
                    text: '输入明码',
                    action: 'lCode'
                },
                {
                    type: 'primary',
                    text: '输入暗码',
                    action: 'dCode'
                },
                {
                    type: 'primary',
                    text: '再次追踪溯源',
                    action: 'trace'
                }
            ]
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        // 是否为明码验证
        isPublic() {
            return this.query.public === '1'
        },
        // 是否为暗码验证
        isDark() {
            return this.query.public === '2'
        },
        // 是否为正品
        isSuccess() {
            return this.query.success === 'true' || this.query.success === true
        },
        // 是否为抽奖
        isPrize() {
            return this.query.type === 'prize'
        },
        // 是否为追踪溯源
        isTrace() {
            return this.query.type === 'trace'
        },
        moduleTitle() {
            return '验证结果'
        },
        resultImg() {
            return this.isSuccess ? this.verifySuc : this.verifyFail
        },
        resultTitle() {
            return this.isSuccess ? '验证成功' : '验证失败'
        },
        resultTag() {
            return this.isSuccess ? '正品' : '伪品'
        },
        // 没有抽奖活动g
        noPrize() {
            return !storage.get('prizeObj')
        },
        buttonList() {
            let arr = []
            if (this.isPublic && this.isSuccess) {
                if (this.noPrize) {
                    arr = this.setButton([0, 1, 3])
                } else {
                    if (this.$store.state.hasLucky) {
                        arr = this.setButton([0, 1, 2])
                        return
                    }
                    arr = this.setButton([0, 1])
                }
            }
            if (this.isPublic && !this.isSuccess) {
                arr = this.setButton([0, 3])
            }
            if (this.isDark) {
                if (this.noPrize) {
                    arr = this.setButton([0, 3])
                } else {
                    arr = this.setButton([0, 2])
                }
            }
            if (this.isPrize && this.isPublic && !this.isSuccess) {
                arr = this.setButton([3, 4])
            }
            if (this.isPrize && this.isDark && !this.isSuccess) {
                arr = this.setButton([3, 5])
            }
            if (this.isTrace && this.isPublic && !this.isSuccess) {
                arr = this.setButton([3, 6])
            }
            return arr
        }
    },
    methods: {
        setButton(arr) {
            const _arr = []
            arr.forEach((item) => {
                _arr.push(this.defaultButtonList[item])
            })
            return _arr
        },
        handleAction(item) {
            // 再次防伪
            if (item.action === 'retry') {
                // this.windowPush('/verify?type=verify&public=1')
                this.replace('/scan-code?type=verify&public=1')
            }
            // 首页
            if (item.action === 'home') {
                this.push('/home')
            }
            // 深度防伪
            if (item.action === 'verifyDark') {
                this.windowPush(`/verify?public_code=${this.query.public_code}&verify_record_id=${this.query.verify_record_id}&type=verify&public=2`)
            }
            // 抽奖
            if (item.action === 'prize') {
                this.handelPrize()
            }
            // 抽奖 - 输入明码
            if (item.action === 'lCode') {
                this.windowPush('/verify?type=prize&public=1')
            }
            // 抽奖 - 输入暗码
            if (item.action === 'dCode') {
                this.windowPush(`/verify?type=prize&public=2&public_code=${this.query.public_code}&verify_record_id=${this.query.verify_record_id}`)
            }
            // 再次追踪溯源
            if (item.action === 'trace') {
                this.windowPush('/verify?type=trace&public=1')
            }
        },
        onClickLeft() {
            this.push('/')
        },
        handleViewPic() {
            this.push(`/verify-approval?codeId=${this.query.public_code}`)
        },
        handelPrize() {
            // 明码校验成功 - 抽奖
            if (this.isPublic && this.isSuccess) {
                this.push(`/prize?public_code=${this.query.public_code}&verify_record_id=${this.query.verify_record_id}`)
                return
            }
            // 明码、暗码校验都成功 - 抽奖
            if (!this.isPublic && this.isSuccess) {
                this.push(`/prize?public_code=${this.query.public_code}&secret_code=${this.query.secret_code}`)
                return
            }
            // 明码或暗码校验失败 - 抽奖
            if (!this.isSuccess) {
                this.windowPush('/verify?type=prize&public=1')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
